import styled from 'styled-components'
import Flex from 'components/Flex'
import { Spin } from 'antd'

export const ShortListModalImg = styled.div`
  text-align: center;
  margin-bottom: 25px;
`
export const ModalText = styled.div`
  color: #010e30;
  text-align: center;
  font-family: Plus Jakarta Sans;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  margin-bottom: 25px;
`

export const ModalTextCor = styled.div`
  color: #010e30;
  text-align: center;
  font-family: Plus Jakarta Sans;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  margin-bottom: 25px;

  span {
  font-weight: 500;
  }
`
export const ModalTextCor1 = styled.div`
  color: #010e30;
  text-align: center;
  font-family: Plus Jakarta Sans;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
`
export const ModalText1 = styled.div`
  color: #010e30;
  text-align: center;
  font-family: Plus Jakarta Sans;
  font-size: 13px;
  font-style: normal;
  font-weight: 500;
  margin-top: -15px;
  margin-bottom: 25px;
`
export const ButtonDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 30px;
`
export const StyledSpin = styled(Spin)`
  .ant-spin-dot-item {
    background-color: #5db594;
  }
`

export const StyledDivision = styled.div`
  padding-top: 12px;
  text-align: center;
  line-height: 1.5;
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-size: 11px;
  white-space: normal;
  word-wrap: break-word;
  overflow-wrap: break-word;
`
export const EventName = styled.div`
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-size: 24px;
  font-weight: 700;
  line-height: 1.4;
  text-align: left;
`
export const MainDiv = styled.div`
  width: 93%;
  border: #d8ddff 2px solid;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  padding-bottom: 20px;
  padding-left: 20px;
  padding-right: 20px;
  border: 2px solid ${props => props.borderColor};
  background-color: ${props => props.backgroundColor};
  color: ${props => props.textColor};
  margin-left: 21px;
  margin-top: 25px;
  margin-bottom: 20px;
  margin-right: 21px;
`
export const StudentDiv = styled.div`
  font-size: 20px;
  padding-top: 30px;
`
export const EventLabel = styled.div`
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-size: 16px;
  font-weight: 700;
  line-height: 20px;
  text-align: left;
  padding-bottom: 12px;
`
export const EventLabel1 = styled.div`
  margin-top: 4px;
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-size: 14px;
  font-weight: 700;
  line-height: 18px;
  text-align: left;
`

export const EventData = styled.div`
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  text-align: left;

  a {
    color: blue;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
`
export const ShowLessText = styled.span`
  cursor: pointer;
  padding-top: 6px;
  padding-bottom: 6px;
  padding-left: 10px;
  padding-right: 10px;
  color: #000;
  display: ${props => (props.visible ? 'inline-block' : 'none')};
  border-radius: 10px;
  // background-color: #e6e7ea;
  width: 25% !important;
  font-weight: bold;
`
export const EventData4 = styled.div`
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 25px;
  text-align: left;
  text-color: black;

  a {
    color: blue;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
`
export const EventData1 = styled.div`
  font-family: Plus Jakarta Sans;
  font-size: 16px;
  font-weight: 700;
  line-height: 18px;
  text-align: left;
`

export const Category = styled.span`
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-size: 24px;
  font-weight: 400;
  padding-bottom: 20px;
`

export const Size = styled.span`
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-size: 10px;
  font-weight: 500;
  padding-bottom: 20px;
  margin-top: 23px;
  margin-left: 5px;
`

export const EventDatecard = styled.div`
  width: 271px;
  height: ${props => (props.hasTime ? '58px' : '43px')};
  border-radius: 47px;
  display: flex;
  flex-direction: column;
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 20px;
  padding-right: 20px;
  border: 2px solid ${props => props.borderColor};
  background-color: ${props => props.backgroundColor};
  color: ${props => props.textColor};
`
export const Uploaders = styled.div`
  display: flex;
  align-items: center;
  width: 235px;
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-size: 14px;
  font-weight: 500;
  height: 44px;
  border-radius: 8px;
  margin-bottom: 20px;
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 20px;
  padding-right: 20px;
  border: 2px solid ${props => props.borderColor};
  background-color: white;
  color: ${props => props.textColor};
  cursor: pointer;
`
export const VerticalDivider = styled.div`
  height: 28px;
  border-left: 1.3px solid ${props => props.borderColor};
`
export const ButtonContainer = styled.div`
  display: flex;
  gap: 10px;
`
export const StyledButton1 = styled.button`
  width: 86px;
  height: 31px;
  border-radius: 22.5px;
  cursor: pointer;
  font-family: Plus Jakarta Sans;
  font-size: 14px;
  line-height: 18px;
  text-align: center;
  border: 0.5px solid ${props => props.borderColor};
  background-color: ${props =>
    props.isClicked ? props.backgroundColor : 'white'};
  color: ${props => props.textColor};
`
export const StyledButton2 = styled.button`
  width: 86px;
  height: 31px;
  border-radius: 22.5px;
  color: #fff;
  border: none;
  cursor: pointer;
  color: black;
  border: 0.5px solid ${props => props.borderColor};
  font-family: Plus Jakarta Sans;
  font-size: 14px;
  line-height: 18px;
  text-align: center;
  background-color: ${props => props.backgroundColor};
  color: ${props => props.textColor};
`

export const Right = styled(Flex)`
  justify-content: flex-end;
  padding-right: 19px;
  padding-bottom: 20px;
  margin-top: -20px;
`
export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
`

export const ModalContent = styled.div`
  background: white;
  padding: 20px;
  border-radius: 5px;
  width: 500px;
  max-width: 100%;
`

export const ModalCheckbox = styled.div`
text-align: center;
gap: 10px;
position: relative;
margin-top: -22px;
padding: 10px;
font-family: 'Plus Jakarta Sans', sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 17.64px;
  color: #A5A5A5;
}
`

export const ButtonShowStudent = styled.button`
  height: fit-content;
  border: 1px solid #e3deff;
  background: #fbfaff;
  color: rgb(50, 73, 215);
  border-radius: 8px;
  font-size: 15px;
  padding: 8px 15px;
  font-weight: 600;
  cursor: pointer;
  // width: 200px;
`
export const EditorContent = styled.span`
  padding: 20px 0;
  * {
    line-height: 188%;
    color: #808697 !important;
  }
  p,
  ul,
  ol {
    margin-bottom: 10px;
  }

  li {
    line-height: 25px;
  }
`
export const categoryStyles = {
  OTHERS: {
    borderColor: '#001B48',
    backgroundColor: 'rgba(0, 27, 72, 0.2)',
    textColor: 'White',
  },
  PRE_PLACEMENT_TALK: {
    borderColor: '#97CADB',
    backgroundColor: 'rgba(151, 202, 219, 0.2)',
    textColor: 'Black',
  },
  SEMINAR: {
    borderColor: '#B5A3F7',
    backgroundColor: 'rgba(181, 163, 247, 0.2)',
    textColor: 'Black',
  },
  WEBINAR: {
    borderColor: '#E1A7BA',
    backgroundColor: 'rgba(225, 167, 186, 0.2)',
    textColor: 'Black',
  },
  LECTURE: {
    borderColor: '#8D6AA0',
    backgroundColor: 'rgba(141, 106, 160, 0.2)',
    textColor: 'White',
  },
  CONFERENCE: {
    borderColor: '#F29F05',
    backgroundColor: 'rgba(242, 159, 5, 0.2)',
    textColor: 'Black',
  },
  PANEL_DISCUSSION: {
    borderColor: '#F25C05',
    backgroundColor: 'rgba(242, 92, 5, 0.2)',
    textColor: 'Black',
  },
  HACKATHON: {
    borderColor: '#31AAB5',
    backgroundColor: 'rgba(49, 170, 181, 0.2)',
    textColor: 'Black',
  },
  WORKSHOP: {
    borderColor: '#72B06F',
    backgroundColor: 'rgba(114, 176, 111, 0.2)',
    textColor: 'Black',
  },
  CAMPAIGN: {
    borderColor: '#4C1D91',
    backgroundColor: 'rgba(76, 29, 145, 0.2)',
    textColor: 'White',
  },
  SPORTS_EVENT: {
    borderColor: '#13593F',
    backgroundColor: 'rgba(19, 89, 63, 0.2)',
    textColor: 'White',
  },
  ACTIVITY_EVENT: {
    borderColor: '#02457A',
    backgroundColor: 'rgba(2, 69, 122, 0.2)',
    textColor: 'White',
  },
  EXHIBITION: {
    borderColor: '#595F33',
    backgroundColor: 'rgba(89, 95, 51, 0.2)',
    textColor: 'White',
  },
}

export const ShowMoreText = styled.span`
  cursor: pointer;
  padding-top: 6px;
  padding-bottom: 6px;
  padding-left: 10px;
  padding-right: 10px;
  color: #000;
  display: ${props => (props.visible ? 'inline-block' : 'none')};
  border-radius: 10px;
  // background-color: #f0f2f4;
  font-weight: bold;
`

export const Container1 = styled.div`
  height: ${props => (props.expanded ? 'auto' : '250px')};

  overflow: hidden;
  overflow-wrap: break-word;
`

export const Content = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 25px;
  color: #808697;
`

export const ExtraPadding = styled.div`
  padding-bottom: 8px;
`
